import { render, staticRenderFns } from "./promotionalView.vue?vue&type=template&id=673eda60&scoped=true&"
import script from "./promotionalView.vue?vue&type=script&lang=js&"
export * from "./promotionalView.vue?vue&type=script&lang=js&"
import style0 from "./promotionalView.vue?vue&type=style&index=0&id=673eda60&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673eda60",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default,ALink: require('/app/components/aLink.vue').default,ObserverHOC: require('/app/components/ObserverHOC/index.vue').default})
